import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { login, me, errMsg } from "../api";

export const AdminLogin = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        // If already authenticated, redirect into dashboard
        const token = localStorage.getItem("strake_token");
        if (!token) return;
        me()
            .then(() => navigate("/admin", { replace: true }))
            .catch(() => localStorage.removeItem("strake_token"));
    }, [navigate]);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setSubmitting(true);
        try {
            const { token } = await login(email.trim().toLowerCase(), password);
            localStorage.setItem("strake_token", token);
            navigate("/admin", { replace: true });
        } catch (err) {
            setError(errMsg(err));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#1A1410] text-[#F5F2EB] flex items-center justify-center px-6">
            <div className="w-full max-w-sm">
                <div className="mb-8 text-center">
                    <div className="text-[10px] uppercase tracking-[0.4em] text-[#D4A437] font-semibold mb-2">— Strake Admin</div>
                    <h1 className="font-display text-4xl uppercase font-bold leading-[0.95] tracking-tight">
                        Sign In
                    </h1>
                </div>

                <form onSubmit={submit} className="space-y-5">
                    <label className="block">
                        <span className="text-[10px] uppercase tracking-[0.3em] text-[#D4A437] font-semibold">Email</span>
                        <input
                            data-testid="admin-login-email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoComplete="username"
                            required
                            className="mt-1 w-full bg-transparent border-b-2 border-[#F5F2EB]/30 focus:border-[#D4A437] outline-none py-2 font-display uppercase tracking-tight text-lg"
                        />
                    </label>

                    <label className="block">
                        <span className="text-[10px] uppercase tracking-[0.3em] text-[#D4A437] font-semibold">Password</span>
                        <input
                            data-testid="admin-login-password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="current-password"
                            required
                            className="mt-1 w-full bg-transparent border-b-2 border-[#F5F2EB]/30 focus:border-[#D4A437] outline-none py-2 font-display tracking-tight text-lg"
                        />
                    </label>

                    {error && (
                        <div data-testid="admin-login-error" className="text-sm text-[#C65A2C] font-body">
                            {error}
                        </div>
                    )}

                    <button
                        data-testid="admin-login-submit"
                        type="submit"
                        disabled={submitting}
                        className="w-full bg-[#D4A437] text-[#1A1410] font-display uppercase tracking-[0.2em] font-bold py-3 active:opacity-80 disabled:opacity-50"
                    >
                        {submitting ? "Signing in…" : "Sign In"}
                    </button>
                </form>
            </div>
        </div>
    );
};
